module.exports = __webpack_public_path__ + "img/OnLeft-MoveRight.87caf5d1.svg";